import Vue from 'vue'
import { get } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { ROUTE_NAMES } from '@/constant/routes'
import utils from '@/util'

export default (TrashView) => Vue.component('TrashController', {
  computed: {
    ...mapGetters('featureToggles', ['canUseTrashBin']),
    ...mapGetters('trash', ['isLoading', 'isRestoring', 'presentations', 'isLoadingMore', 'isLoadAll', 'queryParams']),
  },
  mounted() {
    if (!this.canUseTrashBin) {
      this.$router.replace({ name: ROUTE_NAMES.HOME })
      return
    }
    this.getDataAction()
  },
  destroyed() {
    this.resetTrashStateAction()
  },
  methods: {
    ...mapActions('trash', [
      'getDataAction',
      'restorePresentationAction',
      'getMoreDeletedPresentationAction',
      'sortDeletedPresentationsAction',
      'resetTrashStateAction',
    ]),
  },
  render(createElement) {
    return createElement(TrashView, {
      props: {
        isLoading: this.isLoading,
        presentations: this.presentations,
        folders: this.$store.state.folders,
        isRestoring: this.isRestoring,
        isLoadingMore: this.isLoadingMore,
        sortColumn: this.queryParams.sortColumn,
        sortOrder: this.queryParams.sortOrder,
        onClickRedirectLink: () => {
          this.$router.push({ name: ROUTE_NAMES.PRESENTATIONS })
        },
        onClickRestore: async (presentation) => {
          if (this.isRestoring) return
          const id = get(presentation, 'id', null)
          if (!id) return
          await this.restorePresentationAction(presentation.id)
          const message = `${this.$i18nPresenter.t('Restored presentation')} ${presentation.name}`
          utils.showToastSuccess(message)
        },
        onScrollBottom: () => {
          if (this.isLoadingMore || this.isLoadAll) return
          this.getMoreDeletedPresentationAction()
        },
        onSorting: (columnName) => {
          this.sortDeletedPresentationsAction(columnName)
        },
      },
    })
  },
})
